<template>
    <div
        data-testid="lettr-promo-sidebar"
        class="relative rounded-[12px] border border-red-100 bg-red-50 p-3 shadow-sm"
    >
        <button
            type="button"
            aria-label="Dismiss"
            data-testid="lettr-promo-sidebar-dismiss"
            class="absolute right-2 top-2 rounded-[4px] p-1 text-gray-400 transition duration-100 ease-in-out hover:bg-white hover:text-gray-600"
            @click="dismiss('lettr_sidebar')"
        >
            <XMarkIcon class="h-4 w-4" />
        </button>

        <!-- The wordmark, not the square mark: the card has room for it and
             it is the first time most users will have seen the brand. -->
        <LettrLogo class="h-5 w-[95px] text-gray-900" />

        <h3 class="mt-3 text-sm font-medium text-gray-700">
            Design in Topol, send with Lettr
        </h3>

        <p class="mt-1 text-xs leading-normal text-gray-500">
            The same editor, with sending: transactional over API, marketing as
            campaigns.
        </p>

        <AtomicButton
            class="mt-3 w-full"
            color="yellow"
            size="sm"
            @click="connect('lettr_sidebar')"
        >
            Connect Lettr
        </AtomicButton>
    </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';

import { XMarkIcon } from '@heroicons/vue/24/outline';

import AtomicButton from '@/components/Atomic/Buttons/AtomicButton.vue';
import useLettrPromo from '@/composables/useLettrPromo';

const { trackImpression, dismiss, connect } = useLettrPromo();

onMounted(() => {
    trackImpression('lettr_sidebar');
});
</script>
